const scrollToElement = require('scroll-to-element');

export const initScrollto = () => {
  const buttons = document.querySelectorAll('.btn_scrolldown')
  const form =  document.querySelector('#do-the-test')

  for (var i = buttons.length - 1; i >= 0; i--) {
    buttons[i].addEventListener('click', function () {

      scrollToElement(form, {
        offset: 0,
        ease: 'in-out-quad',
        duration: 700
      })
    })
  }
}
